var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa",class:_vm.direction})])
}
var staticRenderFns = []

export { render, staticRenderFns }